<template>
  <v-card>
    <v-card-title class="ma-0">{{ recursoComputed.nome }}</v-card-title>
    <v-card-text>
      <div v-if="filialComputed === undefined">
        <v-alert border="top" type="info" colored-border elevation="2">Empresa não informada</v-alert>
      </div>
      <v-container class="pa-0" v-else>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="8" lg="12" xl="12">
            <v-text-field prepend-inner-icon="mdi-earth" v-model="url" label="URL"></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="2" lg="6" xl="6">
            <v-text-field prepend-inner-icon="mdi-account" v-model="usr" label="Usuário" @blur="gerarBaseAuth()" @change="gerarBaseAuth()"></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="2" lg="6" xl="6">
            <v-text-field prepend-inner-icon="mdi-lock" v-model="pwd" type="password" label="Senha" @blur="gerarBaseAuth()" @change="gerarBaseAuth()"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon large v-if="isDetalhado" v-on="on" @click="isDetalhado = !isDetalhado" color="primary">mdi-eye</v-icon>
              <v-icon large v-else v-on="on" @click="isDetalhado = !isDetalhado">mdi-eye-outline</v-icon>
            </template>
            <span>{{ isDetalhado ? 'Ocultar detalhamento da requisião' : 'Visualizar detalhamento da requisição' }}</span>
          </v-tooltip>
          </v-col>
        </v-row>
        <v-row v-if="isDetalhado">
          <v-col>

            <v-container fluid>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="2" lg="3" xl="3">
                  Exemplo<br>
                  <v-btn depressed :loading="testando" small @click="testar()" class="mr-2">
                    executar
                  </v-btn>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="10" lg="9" xl="9">
                  <div class="light-green lighten-5 pa-2" style="font-family: monospace; overflow-x:auto !important;">
                    curl -X POST {{ url }} \<br />
                    <span class="ml-5">--header "Authorization: {{ aut }}" \</span><br />
                    <span class="ml-5">--header "Content-Type: application/json" \</span><br />
                    <span class="ml-5">--data "{{ JSON.stringify(recursoComputed.modeloEnvio).replace(/"/g, '\"').replace(/,/g, ', ') }}"</span>
                  </div>
                  <div :class="sucesso ? `light-green lighten-3 pa-2` : `red lighten-3 pa-2`" style="font-family: monospace;" v-if="resposta.data !== undefined">
                    <pre>{{ resposta.data }}</pre>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="2" lg="3" xl="3">
                  Parâmetros
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="10" lg="9" xl="9">
                  <div class="light-green lighten-5 pa-2" style="font-family: monospace;">
                    <pre>{{ JSON.stringify(recursoComputed.modeloEnvio, null, 2) }}</pre>
                  </div>
                  <div>
                    <v-text-field clearable append-icon="mdi-refresh" prepend-icon="mdi-help-circle" @click:prepend="abrirAjudaParametroDeEnvio()" @click:append="populaParametros()" v-model="parametrosText"></v-text-field>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="2" lg="3" xl="3">
                  Retorno<br>Status: 200
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="10" lg="9" xl="9">
                  <div class="light-green lighten-5 pa-2" style="font-family: monospace;">
                    <pre>{{ JSON.stringify(recursoComputed.modeloRetorno, null, 2) }}</pre>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
      <pm-ajuda :key="ajuda.key" :modal="ajuda.ativo" :texto='ajuda.texto' v-on:callback="ajuda.ativo = false"></pm-ajuda>
    </v-card-text>
  </v-card>
</template>
<script>
import Ajuda from '../Ajuda.vue'
import { Base64 } from 'js-base64'
import axios from 'axios'
export default {
  
  name: 'RecursoForm',
  
  data(){
    return {

      url: undefined,
      usr: undefined,
      pwd: undefined,
      aut: undefined,

      resposta: {
        status: undefined,
        data: undefined
      },

      isDetalhado:false,
      parametrosText: undefined,
      testando: false,
      sucesso:true,
      filialTemp: undefined,
      recursoTemp: undefined,

      ajuda: {
        ativo: false,
        key: 0,
        texto: ''
      },

    }
  },

  components: {
    'pm-ajuda': Ajuda,
  },

  props:{
    filial: {
      type: String,
    },
    recurso: {
      type: Object,
      required: true
    }
  },

  mounted(){
    if(this.filialComputed !== undefined){
      this.obterRecurso()
    }
  },

  created: function(){ 
    this.filialComputed = this.filial
    this.recursoComputed = this.recurso
    this.$emit('a')
  },

  watch : {
    salvar: {
      handler() {
        console.log('salvar', this.salvar)
      }
    }
  },

  computed: {
    filialComputed: {
      get() {
        return this.filialTemp
      },
      set(value) {
        this.filialTemp = value
      }
    },
    recursoComputed: {
      get() {
        return this.recursoTemp
      },
      set(value) {
        this.recursoTemp = value
      }
    }
  },

  methods: {

    salvar() {

      let dados = {
        cc_fil: this.filialComputed,
        cc_rec: this.recursoComputed.nome,
        ds_rec: this.recursoComputed.descricao,
        tx_url: this.url,
        cc_aut_usr: this.usr,
        cc_aut_sen: this.pwd
      }

      this.$store.dispatch('salvarRecurso', dados).then(() => {
      }).catch(err => {
        console.log(err)
      })

    },

    obterRecurso() {

      new Promise((accept, reject) => {
        this.$store.dispatch('pesquisaRecurso', {size:9999, cc_fil:this.filialComputed, cc_rec:this.recursoComputed.nome}).then((resp) => {
          if(resp.data.content.length > 0){
            let rec = resp.data.content[0]
            this.url = rec.tx_url
            this.usr = rec.cc_aut_usr
            this.pwd = rec.cc_aut_sen
            accept()  
          }
        }).catch(err => {
          reject(err)
        })
      }).then(() => {
        this.gerarBaseAuth()
      })

    },

    gerarBaseAuth(){
      this.aut = `Basic ${this.base64Encode(`${this.usr}:${this.pwd}`)}`
    },

    populaParametros() {
      if(/^([A-Za-z0-9_]*[=][A-Za-z0-9_]*;)*$/.test(this.parametrosText)){
        console.log(this.parametrosText)
        this.parametrosText.split(';').forEach((el) => {
          if(el !== ''){
            console.log('el', el)

            let elArr = el.split('=')
            console.log('parametro', elArr[0])
            console.log('valor', elArr[1])
            
            if(elArr[0] in this.recursoComputed.modeloEnvio){
              this.recursoComputed.modeloEnvio[elArr[0]] = elArr[1]
            }

          }
        })
      }
    },

    testar() {
      this.testando = true
      new Promise(() => {
        axios({
          url:this.url, 
          data: this.recursoComputed.modeloEnvio,
          method: 'POST', 
          headers:{
            'Content-Type': 'application/json',
            'Authorization': this.aut
          }
        }).then(resp => {
          this.resposta.data = JSON.stringify(resp.data, null, 2)
          this.testando = false
          this.sucesso = true
        }).catch(err => {
          console.log(err)
          this.testando = false
          this.sucesso = false
          this.resposta.data = err
        })
      })
    },

    base64Encode(str) {
      return Base64.encode(str)
    },

    abrirAjudaParametroDeEnvio() {
      this.ajuda.ativo = true;
      this.ajuda.key = Math.random() * Math.random()
      this.ajuda.texto = `
        Modifica o corpo da requisição. Informe os atributos e seus valores da sequinte forma: atributo1=valor1;atributo2=valor2; e click no botao para atualizar o corpo da requisição.`
    },

    
  }

}
</script>